import axios from "axios";
import settings from "utils/settings";
import filterTypes from "data/filter-types";

const apiUrl = `${settings.apiUrl}api/promo-code`;

export const requestSingle = (id) =>
  axios.post(`${apiUrl}/search?page=0&size=1`, {
    criteria: [{
      fieldName: "id",
      fieldValue: id,
      searchOperation: filterTypes.EQUALS.value
    }]
  });

export const requestAdd = (data) =>
  axios.post(`${apiUrl}`, data);

export const requestGetStatuses = () =>
  axios.get(`${apiUrl}/statuses`);



// WEBPACK FOOTER //
// ./src/actions/promo-codes/requests.js